import * as React from 'react';
import {
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogContent,
} from 'components/ui/dialog';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';

import { GeolocationsList, OccurrencesList } from './components';

type TabId = 'geolocations' | 'occurrences'

type Ref = {
  open: () => void;
}

export type GeolocationsAndOccurrencesListDialogRef = Ref

export const GeolocationsAndOccurrencesListDialog
  = React.forwardRef<Ref, {}>((_, ref) => {
  const [open, setOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<TabId>('geolocations');

  React.useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
  }), []);

  return (
    <Dialog open={open} onOpenChange={() => setOpen(false)}>
      <DialogContent className={'w-full max-w-[960px]'}>
        <Tabs defaultValue={'geolocations'} onValueChange={(v) => setActiveTab(v as TabId)}>
          <DialogHeader className={'flex flex-row items-center pr-4 mb-6'}>
            <DialogTitle>
              {activeTab === 'geolocations' && 'Localizações'}
              {activeTab === 'occurrences' && 'Ocorrências'}
            </DialogTitle>
            <TabsList className={'ml-auto'}>
              <TabsTrigger value={'geolocations'}>Localizações</TabsTrigger>
              <TabsTrigger value={'occurrences'}>Ocorrências</TabsTrigger>
            </TabsList>
          </DialogHeader>
          <div className={'h-[calc(100vh-120px)] max-h-[540px]  overflow-y-auto p-4'}>
            <TabsContent value={'geolocations'}>
              <GeolocationsList />
            </TabsContent>
            <TabsContent value={'occurrences'}>
              <OccurrencesList />
            </TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
});
GeolocationsAndOccurrencesListDialog.displayName
  = 'GeolocationsAndOccurrencesListDialog';